import React, { createContext, useContext, useState, ReactNode } from 'react'

export type Page = 
  | 'landing' 
  | 'auth' 
  | 'register' 
  | 'game'
  | 'features'
  | 'pricing'
  | 'blog'
  | 'help'
  | 'careers'
  | 'privacy'
  | 'terms'
  | 'about'
  | 'contact'
  | 'parentsGuide'
  | 'security'
  | 'cookies'

export type Modal = 
  | 'about'
  | 'contact'
  | 'parentsGuide'
  | 'security'
  | 'cookies'
  | null

interface NavigationContextType {
  currentPage: Page
  setCurrentPage: (page: Page) => void
  openModal: (modal: Modal) => void
  closeModal: () => void
  activeModal: Modal
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined)

export function NavigationProvider({ children }: { children: ReactNode }): React.ReactElement {
  const [currentPage, setCurrentPageState] = useState<Page>('landing')
  const [activeModal, setActiveModal] = useState<Modal>(null)

  const setCurrentPage = (page: Page) => {
    console.log('setCurrentPage called with:', page)
    setCurrentPageState(page)
  }

  return (
    <NavigationContext.Provider
      value={{
        currentPage,
        setCurrentPage,
        openModal: setActiveModal,
        closeModal: () => setActiveModal(null),
        activeModal,
      }}
    >
      {children}
    </NavigationContext.Provider>
  )
}

export function useNavigation(): NavigationContextType {
  const context = useContext(NavigationContext)
  if (!context) {
    throw new Error('useNavigation must be used within NavigationProvider')
  }
  return context
}
